var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemConfigurator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98071 5.24908L5.87115 8.12871",
    stroke: "#000000de",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9541 1.37781L5.8028 5.03922L2.27236 8.46442",
    stroke: "#000000de",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3479 12.5829L12.0001 2.54352L1.65225 12.5829",
    stroke: "#000000de",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7915 10.1025V22.6222H12.1086V20.4769M4.23324 10.1025V22.6222H9.47914",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1972 11.4919H13.8273C14.1786 11.4919 14.5298 11.8432 14.5298 12.1945V19.5717C14.5298 19.923 14.1786 20.2743 13.8273 20.2743H10.1972C9.84593 20.2743 9.49463 19.923 9.49463 19.5717V12.1945C9.49463 11.7261 9.84593 11.4919 10.1972 11.4919Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 10.8895V10.8411H13.1434V10.8895H10.9983Z",
    fill: "#000000de",
    stroke: "#000000de"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 2,
    height: 6,
    fill: "#000000de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemConfigurator);
export default __webpack_public_path__ + "static/media/systemConfigurator.46a92e9538e0314b68bbc40aa170d0f3.svg";
export { ForwardRef as ReactComponent };